// extracted by mini-css-extract-plugin
module.exports = {"userInfoMenu":"UserInfo_userInfoMenu__3i-2B","userAvatar":"UserInfo_userAvatar__mLPm8","userName":"UserInfo_userName__1g4RZ","btnLogOut":"UserInfo_btnLogOut__q895B"};